import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../auth/authRoles'

const Dashboard = Loadable(lazy(() => import('../views/dashboard/Dashboard')))

const MyProfilePage = Loadable(lazy(() => import('app/profile/my-profile')))
const ApplicationForm = Loadable(
    lazy(() => import('app/views/Admissions/ApplicationForm'))
)
const Instructions = Loadable(
    lazy(() => import('app/views/dashboard/shared/Instructions'))
)
const WinterSchoolForm = Loadable(
    lazy(() => import('app/views/Admissions/WinterSchoolForm'))
)
const GameDesignForm = Loadable(
    lazy(() => import('app/views/Admissions/GameDesignForm'))
)
// const Apply = Loadable(lazy(() => import('app/views/Admissions/Apply')))
const UpdateProfile = Loadable(lazy(() => import('app/profile/UpdateProfile')))
const UpdateQualifications = Loadable(
    lazy(() => import('app/profile/UpdateQualifications'))
)

const dashboardRoutes = [
    {
        path: '/dashboard',
        element: <Dashboard />,
        auth: authRoles.student,
        // auth: authRoles.admin,
    },

    {
        path: 'my-profile',
        element: <MyProfilePage />,
    },
    {
        path: '/update-profile',
        element: <UpdateProfile />,
    },
    {
        path: '/update-qualification',
        element: <UpdateQualifications />,
    },
    {
        path: '/Admission/Apply/:sessionId/:programId',
        element: <ApplicationForm />,
    },
    {
        path: '/winter-school/apply',
        element: <WinterSchoolForm />,
    },
    {
        path: '/game-design/apply',
        element: <GameDesignForm />,
    },

    {
        path: '/Dashboard/Shared/Instructions',
        element: <Instructions />,
    },
    // {
    //     path: '/Admission/ApplyStepA',
    //     element: <Apply />,
    // },
]

export default dashboardRoutes
